/// <reference path="../../../modules/detailed-wipreport/components/detailed-wipreport.component.ts" />
import { MfBladeComponent, IDetailComponent } from "@framework/components/mf-blade/mf-blade.component";
import * as GeneratedForms from "@framework/components/mf-generated-form/MfGeneratedFormExt";
import {
  JobCardListEstimateComponent, JobCardListActualComponent, JobCardListJobcardsComponent, JobCardListInvoiceComponent, InvoiceListPageComponent, WorkOrderListComponent, UserListPageComponent, OrgListPageComponent, GlobalRoleListPageComponent, PartyAddressSpecificPartyListPageComponent, PartyContactSpecificPartyListPageComponent,
  UserRoleList, UserPermissionList, UserRoleJobList, RoleOrganisationList, RoleJobList, OrganisationUserList, RolePermissionList,
} from "../mf-list-page/ListPageComponentsExt";
import { UserDirectoryRolePermissionsComponent } from "../../../modules/hr/components/user-directory-role-permissions/user-directory-role-permissions.component";
import { DirectoryRolePermissionsComponent } from "../../../modules/hr/components/directory-role-permissions/directory-role-permissions.component";
import { PermissionListComponent } from "../../../modules/hr/components/permission-list/permission-list.component";
import * as ListPageComponents from "../mf-list-page/ListPageComponentsExt";
import * as Requisition from "@common/application/entities/Requisition";
import * as RequisitionItem from "@common/application/entities/RequisitionItem";
import * as StockItemSupplier from "@common/application/entities/StockItemSupplier";
import * as StockItem from "@common/application/entities/StockItem";
import * as Site from "@common/application/entities/Site";
import * as ProjectJobNumber from "@common/application/entities/ProjectJobNumber";
import * as RequisitionPartial from "@common/application/entities/RequisitionPartial";
import * as StockItemFileCabinet from "@common/application/entities/StockItemFileCabinet";
import * as SupplierFileCabinet from "@common/application/entities/SupplierFileCabinet";
import { WorkflowType } from "../../core/Enums";
import { InvoiceDetailsComponent } from "../../../modules/invoicing/components/invoice-details/invoice-details.component";
import { StockListComponent } from "../../../modules/stock/pages/stock-list/stock-list.component";
import { Permissions } from "../../../config/AppEnums";
import { ListPageComponent } from "../mf-list-page/mf-list-page.component";
import { TutorialComponent } from "../../../modules/requisition/components/tutorial/tutorial.component";
import { ReportSelectComponent } from "../../../modules/req-reports/pages/report-select/report-select.component";
import { DetailedWIPReportComponent } from "../../../modules/detailed-wipreport/components/detailed-wipreport.component";
import { ItemDeliveriesComponent } from "../../../modules/requisition/components/item-deliveries/item-deliveries.component";

export class UserSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: UserListPageComponent, isMenuHidden: false },

  ]; protected _hideSideMenu: boolean = true;
}

export class OrgSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: OrgListPageComponent, isMenuHidden: false },

  ]; protected _hideSideMenu: boolean = true;
}



export class OrganisationDetailsBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.OrganisationGeneratedForm },
    { index: 1, displayName: "Roles", component: ListPageComponents.OrganisationRoleList },
    { index: 2, displayName: "Users", component: OrganisationUserList },

  ];
};

export class GlobalRoleSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GlobalRoleListPageComponent, isMenuHidden: false },

  ]; protected _hideSideMenu: boolean = true;
}

export class GlobalRoleDetailsBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RoleGeneratedForm },
    { index: 1, displayName: "Permissions", component: PermissionListComponent },
    { index: 2, displayName: "Organisations", component: RoleOrganisationList },
    { index: 3, displayName: "Sites", component: ListPageComponents.RoleSiteListPageComponent },
    { index: 4, displayName: "Job Numbers", component: ListPageComponents.RoleProjectJobNumberListPageComponent },
    { index: 5, displayName: "EMS Directories", component: DirectoryRolePermissionsComponent },
    { index: 6, displayName: "Warehouses", component: ListPageComponents.RoleWarehouseListPageComponent },

  ];

  public onSaveEvent = function (prop) {
    if (prop.listIndex == 3) {
      prop.parent.reloadDetailComponent(4)
    }
    if (prop.listIndex == 1) {
      prop.parent.reloadDetailComponent(5)
    }
  }
};



export class PartyContactSpecificBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.PartyContactSpecificPartGeneratedyForm, isMenuHidden: false },

  ];

}
export class PartyAddressBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.PartyAddresspecificPartyGenerated, isMenuHidden: false },

  ];

  public onSaveEvent = function (prop) {
    prop.parent.parent.formInstances[1].reloadDetailComponent(2)

  }
}

export class SupplierPartyContactBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.SupplierPartyContactGeneratedForm, isMenuHidden: false },

  ];
  protected _hideSideMenu: boolean = true;

  public onSaveEvent = function (prop) {
    debugger;
    prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(2);

  }
}
export class SupplierPartyAddressBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.SupplierPartyAddressGeneratedForm, isMenuHidden: false },

  ];

  public onSaveEvent = function (prop) {
    prop.parent.parent.formInstances[1].reloadDetailComponent(2)

  }
}

export class UserDetailBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.UserGeneratedForm },
    {
      index: 1, displayName: "Contact Details", component: PartyContactSpecificPartyListPageComponent, bladeIndexToNavigateTo: 2, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 2, displayName: "Addresses", component: PartyAddressSpecificPartyListPageComponent, bladeIndexToNavigateTo: 3, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 3, displayName: "Organisations", component: ListPageComponents.UserOrganisationList, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 4, displayName: "Roles", component: UserRoleList, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 5, displayName: "Permissions", component: UserPermissionList, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 6, displayName: "Sites", component: ListPageComponents.RoleSitePerUserListPageComponent, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 7, displayName: "Job Numbers", component: ListPageComponents.RoleProjectPerUserJobNumberListPageComponent, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
    {
      index: 8, displayName: "EMS Directories", component: UserDirectoryRolePermissionsComponent, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
  ];
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Reset Password", click: function (context) {

        context.confirmationService.confirm({
          message: 'Are you sure that you would like to reset the password?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            context.loading = true;
            context.apiService.post(`/api/User/resetPassword/${context.entityId}`, null)
              .subscribe(o => {
                context.loading = false;
                context.messageService.success('Password reset', 'Password successfully reset');
              }, err => {
                context.loading = false;
                context.messageService.danger('error', 'Could not load');
              })
          },
          reject: () => {

          }
        });
      }, isMenuHidden: function (ent, entityId, newItem) {
        return newItem
      }
    },
  ]

  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.formInstances[0].reloadDetailComponent(0)
    }
    if (prop.listIndex == 3) {
      prop.parent.reloadDetailComponent(4)
    }
    if (prop.listIndex == 4) {
      prop.parent.reloadDetailComponent(5)
      prop.parent.reloadDetailComponent(6)
      prop.parent.reloadDetailComponent(7)
      prop.parent.reloadDetailComponent(8)
    }
    if (prop.listIndex == 5) {
      prop.parent.reloadDetailComponent(8)
    }

  }
}

export class RequisitionBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionGeneratedForm },
    {
      index: 1, displayName: "Unprocessed Items", component: ListPageComponents.RequisitionItemListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) {
        if (newItem)
          return true;
        if (!context)
          return;
        if (context.parent.getFormInstanceByIndex(0).entityData && context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow) {
          if ((context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessing || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessed || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowGRND
            || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowCompleted
          ) && context.parent.getFormInstanceByIndex(1).items != null) {
            if (context.parent.getFormInstanceByIndex(1).items.data) {
              if (context.parent.getFormInstanceByIndex(1).items.data.length == 0)
                return true;
            }
            else if (context.parent.getFormInstanceByIndex(1).items.length == 0) {
              return true;
            }
            else return false;
          }

          else return false;
        }
        return;
      }
    },
    {
      index: 2, displayName: "Processed Items", component: ListPageComponents.RequisitionPartialListPageComponent, bladeIndexToNavigateTo: 6, isMenuHidden: function (context, entityId, newItem, listIndex, data) {
        if (newItem)
          return true;
        if (listIndex != 2)
          return;
        if (data != null && data.length > 0)
          return false;
        else return true;
      }, getDataEvenIfIsMenuHidden: true
    },
    { index: 3, displayName: "Documents", component: ListPageComponents.RequisitionFileCabinetListPageComponent, bladeIndexToNavigateTo: 4, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
    { index: 4, displayName: "Workflow / Notes", component: ListPageComponents.RequisitionWorkflowListPageComponent, bladeIndexToNavigateTo: 3, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
    { index: 5, displayName: "Change History", component: ListPageComponents.AuditTrailReqListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },

    {
      index: 6, displayName: "Deliveries", component: ItemDeliveriesComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) {
        if (newItem)
          return true;
        if (listIndex != 6)
          return;
        
        else {
          if (context.parent.getFormInstanceByIndex(0).entityData && context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow) {
            if ((context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessing || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessed || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowGRND
              || context.parent.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType == WorkflowType.WorkflowCompleted
            )) {
              if (data != null && data.length > 0)
                return false;
            }
          }
        }
        return true;
      }, getDataEvenIfIsMenuHidden: true
    },
  ];
  public _bladeSetup: any = new Requisition.RequisitionBladeSetup();
};

export class RequisitionListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: ListPageComponents.RequisitionListPageComponent, isMenuHidden: false }
  ];
  protected _hideSideMenu: boolean = true;

  // public _bladeSetup: any = new Requisition.RequisitionListBladeSetup();


}

export class InvoiceListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: ListPageComponents.InvoiceFullListPageComponent, isMenuHidden: false }
  ]; protected _hideSideMenu: boolean = true;
}

export class CustomInvoiceListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: ListPageComponents.InvoiceCustomListPageComponent, isMenuHidden: false }
  ]; protected _hideSideMenu: boolean = true;
}
export class CustomInvoiceBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: InvoiceDetailsComponent, isMenuHidden: false }
  ]; protected _hideSideMenu: boolean = true;
}



export class RequisitionItemBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionItemGeneratedForm },
    //{ index: 1, displayName: "Documents", component: ListPageComponents.RequisitionItemFileCabinetListPageComponent, bladeIndexToNavigateTo: 5 ,isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
    { index: 1, displayName: "Workflow / Notes", component: ListPageComponents.RequisitionItemWorkflowListPageComponent, bladeIndexToNavigateTo: 5, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
    { index: 2, displayName: "Change History", component: ListPageComponents.AuditTrailReqItemListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemBladeSetup();

};
export class RequisitionPartialItemBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionItemGeneratedForm },
    //{ index: 1, displayName: "Documents", component: ListPageComponents.RequisitionItemFileCabinetListPageComponent, bladeIndexToNavigateTo: 5 },
    { index: 1, displayName: "Workflow / Notes", component: ListPageComponents.RequisitionItemWorkflowListPageComponent, bladeIndexToNavigateTo: 5 },
    { index: 2, displayName: "Change History", component: ListPageComponents.AuditTrailReqItemListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemBladeSetup();

};

export class RequisitionItemProcessedBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionItemGeneratedForm },
    //{ index: 1, displayName: "Documents", component: ListPageComponents.RequisitionItemFileCabinetListPageComponent, bladeIndexToNavigateTo: 9 },
    { index: 1, displayName: "Workflow / Notes", component: ListPageComponents.RequisitionItemWorkflowListPageComponent, bladeIndexToNavigateTo: 8 },
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemBladeSetup();

};


export class RequisitionWorkflowBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionWorkflowGeneratedForm, isMenuHidden: false }
  ];
  protected _hideSideMenu: boolean = true;
};
export class RequisitionItemWorkflowBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionItemWorkflowGeneratedForm, isMenuHidden: false }
  ];
  protected _hideSideMenu: boolean = true;
};



export class WorkOrderBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.WorkOrderGeneratedForm },
    { index: 1, displayName: "Estimate Cards", component: JobCardListEstimateComponent },
    { index: 2, displayName: "Job Cards", component: JobCardListJobcardsComponent },
    { index: 3, displayName: "Actual Costing Cards", component: JobCardListActualComponent },
    { index: 4, displayName: "Invoice Cards", component: JobCardListInvoiceComponent },
  ];
}

export class JobCardBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties ", component: GeneratedForms.JobCardGeneratedForm },
    { index: 1, displayName: "Invoice Items", component: InvoiceListPageComponent },
  ];
}

export class InvoiceBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.InvoiceGeneratedForm, isMenuHidden: false },
  ];
}

export class WorkOrderSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: WorkOrderListComponent, isMenuHidden: false },
  ]; protected _hideSideMenu: boolean = true;
}
export class RequisitionFileCabinetBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionFileCabinetGeneratedForm, isMenuHidden: false },
  ];
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(3);
    }
  }
  protected _hideSideMenu: boolean = true;
}
export class RequisitionItemFileCabinetBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionItemFileCabinetGeneratedForm, isMenuHidden: false },
  ];
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(2).reloadFormByIndex(1);
      prop.parent.parent.getBladeByIndex(8).reloadFormByIndex(1);
    }
  }
  protected _hideSideMenu: boolean = true;
}
export class RequisitionPartialBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.RequisitionPartialGeneratedForm },
    { index: 1, displayName: "Items", component: ListPageComponents.RequisitionPartialRequisitionItemListPageComponent },
    { index: 2, displayName: "Workflow / notes", component: ListPageComponents.RequisitionPartialWorkflowListPageComponent, },

  ];

  public _bladeSetup: any = new RequisitionPartial.RequisitionPartialBladeSetup();
}

export class SupplierSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: ListPageComponents.SupplierListPageComponent, isMenuHidden: false }
  ]; protected _hideSideMenu: boolean = true;
}
export class SupplierDetailBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.SupplierGeneratedForm },
    { index: 1, displayName: "Documents", component: ListPageComponents.SupplierFileCabinetDocumentsListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem }, },
    { index: 2, displayName: "Contacts", component: ListPageComponents.SupplierPartyContactListPageComponent, bladeIndexToNavigateTo: 3, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem }, },
  ];

  public onFormLoad = function (data: any, formIndex: any, context: any) {
    if (formIndex == 0) {
      if (!context.authService.hasAnyPermissions(Permissions.SupplierEdit)) {
        context.parent.componentInstance[0].component.makeFormReadOnly(true);
        if (!context.authService.hasAnyPermissions(Permissions.SupplierManageDocuments)) {
          context.parent.componentInstance[1].component.makeFormReadOnly(true);
        }
        else {
          context.parent.componentInstance[1].component.makeFormReadOnly(false);
        }
        context.parent.componentInstance[2].component.makeFormReadOnly(true);
      }
      else {
        context.parent.componentInstance[0].component.makeFormReadOnly(false);

        context.parent.componentInstance[1].component.makeFormReadOnly(false);
        context.parent.componentInstance[2].component.makeFormReadOnly(false);
      }


    }
  }
}

export class SiteSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: ListPageComponents.SiteListPageComponent, isMenuHidden: false }
  ]; protected _hideSideMenu: boolean = true;
}
export class SiteDetailBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.SiteGeneratedForm },
    { index: 1, displayName: "Job Numbers", component: ListPageComponents.SiteProjectJobNumbersListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } }
  ];


  public _bladeSetup: any = new Site.BladeSetup();
}

export class ProjectJobNumberBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Properties", component: GeneratedForms.ProjectJobNumberGeneratedForm, isMenuHidden: false }
  ];


  public _bladeSetup: any = new ProjectJobNumber.BladeSetup();
}

export class StockSearchBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Properties", component:
        StockListComponent, isMenuHidden: false
    }
  ]; protected _hideSideMenu: boolean = true;
  protected _smallTop: boolean = true;
}

export class StockItemBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Properties", component: GeneratedForms.StockItemGeneratedForm
    },

    { index: 1, displayName: "Supplied by", component: ListPageComponents.StockItemSupplierListPageCompoment, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem } },
    { index: 2, displayName: "Photos", component: ListPageComponents.StockItemFileCabinetPicturesListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem }, bladeIndexToNavigateTo: 3, },
    { index: 3, displayName: "Documents", component: ListPageComponents.StockItemFileCabinetDocumentsListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem }, bladeIndexToNavigateTo: 3, },
    { index: 4, displayName: "Change Tracking", component: ListPageComponents.AuditTrailStockItemListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem || !context || !context.authService || (context && context.authService && !context.authService.hasAnyPermissions(Permissions.StockItemsModuleEdit)) } },


  ];
  public _bladeSetup: any = new StockItem.BladeSetup();

}

export class StockItemSupplierBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Properties", component: GeneratedForms.StockItemSupplierGeneratedForm,
    },
    { index: 1, displayName: "Change Tracking", component: ListPageComponents.AuditTrailStockItemSupplierListPageComponent, isMenuHidden: function (context, entityId, newItem, listIndex, data) { return newItem || !context || !context.authService || (context && context.authService && !context.authService.hasAnyPermissions(Permissions.StockItemsModuleEdit)) } }
  ];


  public _bladeSetup: any = new StockItemSupplier.BladeSetup();
}

export class StockItemFileCabinetBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Properties", component: GeneratedForms.StockItemFileCabinetGeneratedForm, isMenuHidden: true,
    }
  ];
  public _bladeSetup: any = new StockItemFileCabinet.BladeSetup();
}

export class SupplierFileCabinetBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Properties", component: GeneratedForms.SupplierFileCabinetGeneratedForm, isMenuHidden: true,
    }
  ];
  public _bladeSetup: any = new SupplierFileCabinet.BladeSetup();
}

export class RequisitionItemReportListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Filter", component: ListPageComponents.RequisitionItemReportListPageComponent, isMenuHidden: false }
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemReportListBladeSetup();
}

export class RequisitionItemDetailedReportListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Filter", component: ListPageComponents.RequisitionItemDetailReportListPageComponent, isMenuHidden: false }
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemDetailedReportListBladeSetup();
}

export class RequisitionReportActionsRequiredListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Filter", component: ListPageComponents.RequisitionReportActionsRequiredListPageComponent, isMenuHidden: false }
  ];

  public _bladeSetup: any = new Requisition.RequisitionReportActionRequiredListBladeSetup(); protected _hideSideMenu: boolean = true;
}

export class RequisitionItemReportOutstandingItemsListBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Filter", component: ListPageComponents.RequisitionItemReportOutstandingItemsListPageComponent, isMenuHidden: false }
  ];

  public _bladeSetup: any = new RequisitionItem.RequisitionItemReportOutstandingItemsListBladeSetup();
}

export class RequisitionTutorialBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "How it Works", component: TutorialComponent, isMenuHidden: true }
  ]; protected _hideSideMenu: boolean = true;

  public _bladeSetup: any = new RequisitionItem.RequisitionItemReportListBladeSetup();
}

export class RequisitionReportSelectBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "List of reports", component: ReportSelectComponent, isMenuHidden: true }
  ]; protected _hideSideMenu: boolean = true;

}

export class DetailedWIPReportBlade extends MfBladeComponent {
  public detailComponents: Array<IDetailComponent> = [
    { index: 0, displayName: "Detailed Wip Report", component: ListPageComponents.DetailedWIPReportListPageComponent, isMenuHidden: true }
  ];
  protected _hideSideMenu: boolean = true;
}
